import React, {Component} from 'react';
import './VideoPlayer.scss';
import {IntlProvider} from "react-intl";
import {Util} from "../../providers/Utils";
import languageManager from "../../providers/data-manager/language-manager";

const TAG = "VideoPlayer";
class ImagePlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        console.log("Videoplayer did mount: ", this.props.video);
    }

    play() {
        /*ReactGA.event({
            category: 'Video',
            action: 'VideoPlay'
        });*/
        const videoUrl = Util.getMediaUrl(this.props.video) || "";
        window._paq.push(["trackEvent", "video", "Play", videoUrl, {dimension1: this.props.walk ? this.props.walk.Id : null, dimension2: this.props.location ? this.props.location.Id : null, dimension3: languageManager.currentLangCode}]);
    }
    stop() {
        /*ReactGA.event({
            category: 'Video',
            action: 'VideoStopped'
        });*/
        const videoUrl = Util.getMediaUrl(this.props.video) || "";
        window._paq.push(["trackEvent", "video", "Stopped", videoUrl, {dimension1: this.props.walk ? this.props.walk.Id : null, dimension2: this.props.location ? this.props.location.Id : null, dimension3: languageManager.currentLangCode}]);
    }
    pause() {
        /*ReactGA.event({
            category: 'Video',
            action: 'VideoPaused'
        });*/
        const videoUrl = Util.getMediaUrl(this.props.video) || "";
        window._paq.push(["trackEvent", "video", "Paused", videoUrl, {dimension1: this.props.walk ? this.props.walk.Id : null, dimension2: this.props.location ? this.props.location.Id : null, dimension3: languageManager.currentLangCode}]);
    }

    render() {
        const videoUrl = Util.getMediaUrl(this.props.video) || "";
        const posterUrl = Util.getMediaUrl(this.props.videoPoster) || "";
        console.log(TAG, "VideoURL: ", videoUrl);
        if(videoUrl) {
            return (
                <div className={"VideoPlayer"}>
                    <video src={videoUrl} poster={posterUrl} controls onPlay={this.play.bind(this)} onPause={this.pause.bind(this)} onEnded={this.stop.bind(this)}/>
                </div>

            );
        } else {
            return <></>
        }

    }

}
/*
<div className="imagePlayer">
					<div className="scrollthingi">
						<div className="images">
							{imageNodes}
						</div>
					</div>
					<div className={dotnodeclass}>
						{dotnodes}
					</div>
					{lefticon}
					{righticon}
					{caption}
					<div className="fullscreen_button" onClick={this.openFullscreen}>
						<Icon name={fullscreen}/>
					</div>

				</div>
 */


export default ImagePlayer;
